import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {VectorItemObject} from '@PosterWhiteboard/items/vector-item/vector-item.types';

export function useGetKeyFromActiveVectorItem<T extends keyof VectorItemObject>(key: T): VectorItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];
    const copyItem = item as VectorItemObject;
    if (copyItem?.[key] !== undefined) {
      return copyItem[key];
    }

    return undefined;
  });
}
